import React from 'react';
import { render } from 'react-dom';
import Website from './components';


render(<Website />, document.getElementById('root'));
